import React, { useState } from 'react';
import DeckGL from '@deck.gl/react';
import { H3HexagonLayer } from '@deck.gl/geo-layers';
import { StaticMap } from 'react-map-gl';
import MapLegend from './map-legend.component';
import Selector from './selector.component';

const Map = (props) => {
	const mapboxApiKey =
		'pk.eyJ1IjoibGNhc3RpbGxvODQiLCJhIjoiY2s5ajFrY2FpMDRodDNvbzR2aGVmbmFsbiJ9.NjDTW19--KfhAB-LapY_ag';

	const {
		operatorData,
		operatorName,
		viewState,
		currentMetric,
		legends,
		mapType,
		handleViewStateChange,
		earfcnToBand,
	} = props;
	const [earfcn, setEarfcn] = useState('best');

	let mapStyleUrl = '';
	switch (mapType) {
		case 'light':
			mapStyleUrl = 'mapbox://styles/mapbox/light-v10';
			break;
		case 'dark':
			mapStyleUrl = 'mapbox://styles/mapbox/dark-v10';
			break;
		case 'streets':
			mapStyleUrl = 'mapbox://styles/mapbox/streets-v11';
			break;
		default:
			mapStyleUrl = 'mapbox://styles/mapbox/light-v10';
	}

	const h3Data = operatorData.find((item) => item.earfcn.toString() === earfcn.toString());

	const legend = legends[currentMetric];

	const earfcns = [];
	operatorData.map((item) =>
		earfcns.push({
			name: item.earfcn,
			label:
				item.earfcn === 'best'
					? 'La mejor portadora'
					: `${item.earfcn} (${earfcnToBand[item.earfcn]})`,
		})
	);

	const getColor = (level) => {
		const levelFound = legend.find((item) => item.value === level);
		const color = levelFound ? levelFound.color : [0, 0, 0];
		return color;
	};

	const handleEarfcnChange = (e) => {
		setEarfcn(e.target.value);
	};

	let layers = [];

	// filtrar data
	layers.push(
		new H3HexagonLayer({
			data: h3Data[currentMetric],
			pickable: true,
			extruded: false,
			getHexagon: (d) => d.h3_hexagon,
			getFillColor: (d) => getColor(parseInt(d.level)),
			getLineColor: [0, 0, 0],
			getLineWidth: 1,
			getElevation: (d) => 0,
		})
	);

	// Nombre Operador
	const operatorNameTxt = operatorName.replace(/[^a-zA-Z]/g, '');

	return (
		<div style={{ position: 'relative', height: '100%', width: '100%' }}>
			<DeckGL
				controller={true}
				viewState={viewState}
				onViewStateChange={handleViewStateChange}
				layers={layers}
			>
				<MapLegend legend={legend} metricName={currentMetric} />
				<Selector
					name={`earfcn_${operatorNameTxt}`}
					title='#Canal'
					options={earfcns}
					value={earfcn}
					onChange={handleEarfcnChange}
					backgroundColor='lightgray'
					isAbsolute
					smallFont
				/>
				<StaticMap mapboxApiAccessToken={mapboxApiKey} mapStyle={mapStyleUrl} />
			</DeckGL>
		</div>
	);
};

export default Map;
